module.exports = require('./lib/linkify');



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/index.js
// module id = 204
// module chunks = 1